import React from "react";
import { Card } from "@/components/ui/card";
import { tid } from "@/lib/testids";
import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <div data-testid={tid.privacyPage} className="mx-auto max-w-4xl px-4 py-10">
      <Seo title="Privacy Policy" description="AskIncog Privacy Policy." />
      <Card className="border-slate-200/70 bg-white p-8">
        <h1 className="text-3xl font-bold text-slate-900">Privacy Policy</h1>
        <p className="mt-3 text-sm leading-7 text-slate-600">
          Questions are posted anonymously. If you log in to contribute answers, we store your email, name,
          and profile picture to attribute your responses. We use cookies for authentication sessions.
        </p>
      </Card>
    </div>
  );
}
